module.exports = __webpack_public_path__ + "static/media/img5.2276a1be.webp";